// Copyright (c) 2019 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getCustomer} from '../../../pip/shared/repositories';

export const readCustomer = (id, customerPrivate) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getCustomer(id, customerPrivate);

            dispatch({
                data,
                type: actions.SET_CLAIM_WEAR_PARTS_CUSTOMER_DETAILS
            });

        } catch (error) {

            dispatch({
                ckcCustomerFailed: true,
                type: actions.UPDATE_CKC_CUSTOMER_FAILURE
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/get-customer-details.js